<template>
  <div>
    <p>
      Enclosures of every type and size to fit your project goals can be custom-designed, manufactured and installed at
      your location.
    </p>
    <carousel item="enclosures" :images="images"></carousel>
  </div>
</template>

<script>
  import Carousel from '@/components/Carousel'

  export default {
    name: "Enclosures",
    components: {Carousel},
    data() {
      return {
        images: [
          'enclosures-0.jpeg',
          'enclosures-1.jpeg',
          'enclosures-2.jpeg',
          'enclosures-3.jpeg'
        ]
      }
    }
  }
</script>

<style scoped>

</style>